import { RoundedBox } from '@react-three/drei'
import {
  COMPRIMENTO_MEIA_PRANCHA,
  ESPESSURA_MEIA_PRANCHA,
  LARGURA_MEIA_PRANCHA,
} from '../../dominio/didatico/meiaPrancha'

interface PropsMeiaPrancha {
  visivel?: boolean
  posicao?: [number, number, number]
  rotacao?: [number, number, number]
  escala?: number
}

/**
 * Meia-Prancha 3D (Prancha Curta de Resgate).
 *
 * Utilizada para imobilização tóraco-lombar e cervical prévia da vítima sentada.
 * Posicionada atrás do tronco antes da transição para a prancha longa ou giro.
 */
export function MeiaPrancha3D({
  visivel = true,
  posicao = [0, 0, 0],
  rotacao = [0, 0, 0],
  escala = 1,
}: PropsMeiaPrancha) {
  if (!visivel) return null

  return (
    <group position={posicao} rotation={rotacao} scale={escala}>
      {/* Tabuleiro da meia-prancha */}
      <mesh>
        <RoundedBox
          args={[LARGURA_MEIA_PRANCHA, COMPRIMENTO_MEIA_PRANCHA, ESPESSURA_MEIA_PRANCHA]}
          radius={0.015}
          smoothness={2}
        >
          <meshStandardMaterial color="#f59e0b" roughness={0.5} metalness={0.08} />
        </RoundedBox>
      </mesh>

      {/* Pegas ergonômicas laterais */}
      {[-1, 1].map((lado) => (
        <group key={lado}>
          {[-0.22, 0, 0.22].map((y) => (
            <mesh
              key={y}
              position={[lado * (LARGURA_MEIA_PRANCHA / 2 - 0.04), y, 0]}
            >
              <boxGeometry args={[0.035, 0.09, ESPESSURA_MEIA_PRANCHA * 1.05]} />
              <meshBasicMaterial color="#18181b" />
            </mesh>
          ))}
        </group>
      ))}

      {/* Cintas de fixação rápida (tiras de velcro/fivelas cruzadas) */}
      <mesh position={[0, 0.12, ESPESSURA_MEIA_PRANCHA / 2 + 0.002]}>
        <boxGeometry args={[LARGURA_MEIA_PRANCHA * 0.92, 0.045, 0.004]} />
        <meshStandardMaterial color="#ef4444" roughness={0.7} />
      </mesh>
      <mesh position={[0, -0.15, ESPESSURA_MEIA_PRANCHA / 2 + 0.002]}>
        <boxGeometry args={[LARGURA_MEIA_PRANCHA * 0.92, 0.045, 0.004]} />
        <meshStandardMaterial color="#2563eb" roughness={0.7} />
      </mesh>
    </group>
  )
}

